import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  // Check if user has a preferred theme saved in localStorage, default to light
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  });

  // Apply theme when it changes
  useEffect(() => {
    const html = document.documentElement; // Get the html element
    
    if (isDarkMode) {
      document.body.classList.add('dark-mode');
      html.classList.add('dark-mode'); // Add dark-mode to html element too
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark-mode');
      html.classList.remove('dark-mode'); // Remove from html element too
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  // Toggle between dark and light mode
  const toggleTheme = useCallback(() => {
    setIsDarkMode(prevMode => !prevMode);
  }, []);

  const contextValue = useMemo(() => ({ isDarkMode, toggleTheme }), [isDarkMode, toggleTheme]);

  return (
    <ThemeContext.Provider value={contextValue}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider; 